export default __webpack_public_path__ + "static/media/guide_to_freedom.f276caf4.png";